<div class="grid">
	<div class="col-12">
	  <div class="card" *ngIf="user">
		<h5>Campañas de Inversión de {{user.name}} <small>{{user.email}}</small></h5>
		<p-table
		  #dt1
		  [value]="investments"
		  dataKey="id"
		  [rows]="10"
		  [loading]="loading"
		  [rowHover]="true"
		  paginator="true"
		  [globalFilterFields]="['name', 'start_date', 'end_date', 'interest']"
		  responsiveLayout="scroll"
		  [sortField]="'start_date'"
		  [sortOrder]="-1"
		>
		  <ng-template pTemplate="caption">
			<div class="flex justify-content-between flex-column sm:flex-row">
			  <button
				pButton
				label="Limpiar"
				class="p-button-rounded mb-2"
				(click)="clear(dt1)"
			  ></button>
			  <span class="p-input-icon-left">
				<i class="pi pi-circle-fill"></i>
				<input
				  pInputText
				  type="text"
				  #filter
				  (input)="dt1.filterGlobal($event.target.value, 'contains')"
				  placeholder="Buscar"
				  class="w-full"
				/>
			  </span>
			  <div class="text-right">
				<button
				  pButton
				  tooltipPosition="top" 
				  pTooltip="Nueva inversión"
				  class="p-button-raised p-button-outlined m-1"
				  icon="pi pi-plus"
				  (click)="showDialog()"
				></button>
				<button
				  pButton
				  pRipple
				  label="Actualizar"
				  tooltipPosition="top" 
				  pTooltip="Actualizar listado de inversiones"
				  type="button"
				  icon="pi pi-refresh"
				  class="p-button-raised p-button-outlined m-1"
				  (click)="loadInvestmentsUser(); clear(dt1)"
				></button>
			  </div>
			</div>
		  </ng-template>
  
		  <ng-template pTemplate="header">
			<tr>
				<th [style.width]="'120px'" pSortableColumn="start_date" class="text-center">
					Inicio <p-sortIcon field="start_date"></p-sortIcon>
				</th>
				<th [style.width]="'120px'" pSortableColumn="end_date" class="text-center">
					Fin <p-sortIcon field="end_date"></p-sortIcon>
				</th>
				<th class="text-center">Referencia</th>
				<th [style.width]="'120px'" pSortableColumn="name" class="text-center">
					Título <p-sortIcon field="name"></p-sortIcon>
				</th>
				<th class="text-center">Interés</th>
				<th class="text-center">Moneda</th>
				<th class="text-center">Importe</th>
				<th class="text-center">Saldo actual</th>
				<th class="text-center">Transacciones</th>
				<th pSortableColumn="status" class="text-center">
					Estatus  <p-sortIcon field="status"></p-sortIcon>
				</th>
				<th></th>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="body" let-investment>
			<tr>
				<td class="text-center">
				  {{ investment.start_date | date: 'dd-MM-yyyy' }}
				</td>
				<td class="text-center">
				  {{ investment.end_date | date: 'dd-MM-yyyy' }}
				</td>
				<td class="text-center">{{ investment.reference }}</td>
				<td class="text-center">{{ investment.name }}</td>
				<td class="text-center">{{ formatNumber(investment.interest) }}%</td>
				<td class="text-center">{{ investment.currency || 'EUR' }}</td>
				<td class="text-center">{{ formatNumber(investment.amount) }} {{ getCurrencySymbol(investment.currency) }}</td>
				<td class="text-center">{{ formatNumber(investment.total) }} {{ getCurrencySymbol(investment.currency) }}</td>
				<td class="text-center">{{ investment.transactions.length }}</td>
				<td class="text-center">{{ investment.status == 1 ? 'Activo' : investment.status == 0 ? 'Desactivada' : investment.status == 2 ? 'Cancelada' : 'Eliminado' }}</td>
				<td class="text-center">
					<button
					pButton
					pRipple
					type="button"
					tooltipPosition="top" 
					pTooltip="Ver Gráfica"
					icon="pi pi-chart-bar"
					class="p-button-dark p-button-raised p-button-outlined m-1"
					(click)="graphics(investment)"
					></button>
					<button
					pButton
					pRipple
					type="button"
					tooltipPosition="top" 
					pTooltip="Transacciones"
					icon="pi pi-money-bill"
					class="p-button-info p-button-raised p-button-outlined m-1"
					(click)="transactions(investment)"
					></button>
					<button
					pButton
					pRipple
					type="button"
					tooltipPosition="top" 
					pTooltip="Eliminar inversión"
					icon="pi pi-trash"
					class="p-button-danger p-button-raised p-button-outlined m-1"
					(click)="deleteInvestment(investment)"
					></button>
					<button
					pButton
					pRipple
					type="button"
					tooltipPosition="top" 
					pTooltip="Editar inversión"
					icon="pi pi-pencil"
					class="p-button-raised p-button-outlined m-1"
					(click)="showDialog(investment)"
					></button>
			  </td>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="10" class="text-center">Sin resultados</td>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="loadingbody">
			<tr>
			  <td colspan="10">Cargando inversiones...</td>
			</tr>
		  </ng-template>
		</p-table>
	  </div>
	</div>
  </div>
  
  <!-- Diálogo para recortar la imagen -->
  <p-dialog
	header="Recortador de imagen"
	[style]="{ width: '70vw' }"
	[(visible)]="croppedActive"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
  >
	<div class="croppe">
		<image-cropper
		[imageChangedEvent]="imageChangedEvent"
		[maintainAspectRatio]="true"
		[aspectRatio]="1 / 1"
		resizeToHeight="512"
		format="jpeg"
		output="base64"
		(imageCropped)="imageCropped($event)"
		(imageLoaded)="imageLoaded($event)"
		(cropperReady)="cropperReady()"
		(loadImageFailed)="loadImageFailed()"
		class="cropper">
	  </image-cropper>
	</div>
  </p-dialog>
  
  <!-- Diálogo para crear/editar inversión -->
  <p-dialog
	header="Datos de la inversión"
	[(visible)]="dialogInvestment"
	[modal]="true"
	[style]="{ width: '60vw' }"
	[draggable]="false"
	[resizable]="false"
	(onHide)="resetForm()"
  >
	<form [formGroup]="form">
		<!-- Sección para imagen -->
		<div class="container-img">
		  <div class="custom-file-upload" *ngIf="stringPhoto">
			<img [src]="stringPhoto" style="width: 220px" alt="Foto cargada" />
			<button type="button" pButton icon="pi pi-trash" class="ml-2" (click)="deletePhoto()" *ngIf="stringPhoto"></button>
		  </div>
		  <div class="custom-file-upload">
			<input id="photoInputImage" type="file" (change)="handleUpload($event)" accept=".jpg,.png" />
			<label class="btn-img">Selecciona imagen</label>
		  </div>
		</div>

	  <div class="grid p-fluid mt-3">
		<div class="field col-12 md:col-3">
		  <label>Referencia *</label>
		  <input
			type="text"
			formControlName="reference"
			pInputText
			class="w-full mb-3"
		  />
		  <small
			class="p-error"
			*ngIf="form.get('reference').invalid && form.get('reference').touched"
			>Requerido</small
		  >
		</div>
		<div class="field col-12 md:col-9">
		  <label>Titulo *</label>
		  <input
			type="text"
			formControlName="name"
			pInputText
			class="w-full mb-3"
		  />
		  <small
			class="p-error"
			*ngIf="form.get('name').invalid && form.get('name').touched"
			>Requerido</small
		  >
		</div>
		  
		<div class="field col-12 md:col-3">
			<label>Importe *</label>
			<input
			  type="number"
			  formControlName="amount"
			  pInputText
			  step="0.01"
			  class="w-full mb-3"
			/>
			<small
			  class="p-error"
			  *ngIf="form.get('amount').invalid && form.get('amount').touched"
			  >Requerido y debe ser numérico</small
			>
		</div>

		<div class="field col-12 md:col-2">
			<label>Moneda *</label>
			<p-dropdown
			  [options]="currencyOptions"
			  optionValue="value"
			  optionLabel="label"
			  formControlName="currency"
			  placeholder="Moneda"
			></p-dropdown>
			<small
			  class="p-error"
			  *ngIf="form.get('currency').invalid && form.get('currency').touched"
			  >Requerido</small
			>
		</div>

		<div class="field col-12 md:col-2">
		  <label>Interés %*</label>
		  <input
			type="number"
			formControlName="interest"
			pInputText
			step="0.01"
			class="w-full mb-3"
		  />
		  <small
			class="p-error"
			*ngIf="form.get('interest').invalid && form.get('interest').touched"
			>Requerido y debe ser numérico</small
		  >
		</div>
		<div class="field col-12 md:col-3">
		  <label>Fecha de inicio</label>
		  <p-calendar
		    appendTo="body"
			formControlName="start_date"
			dateFormat="dd-mm-yy"
		  ></p-calendar>
		</div>
		<div class="field col-12 md:col-3">
		  <label>Fecha de fin</label>
		  <p-calendar
		    appendTo="body"
			formControlName="end_date"
			dateFormat="dd-mm-yy"
		  ></p-calendar>
		</div>
	  </div>
	  <div class="grid p-fluid mt-3">
		<div class="field col-12">
		  <label>Observaciones</label>
		  <textarea
			formControlName="description"
			pInputTextarea
			rows="3"
			class="w-full"
		  ></textarea>
		</div>
	  </div>
	  <div class="flex justify-content-end mt-3">
		<p-button
		  styleClass="p-button-rounded"
		  [label]="mode === 'register' ? 'Guardar' : 'Actualizar'"
		  (click)="mode === 'register' ? registerInvestment() : updateInvestment()"
		  [loading]="loading"
		></p-button>
	  </div>
	</form>
  </p-dialog>
  